export default "__VITE_ASSET__Bq0X29j4__"